import React, { useEffect, useState } from "react";
import { useSignUpContext } from "../../../context/SignUpContext";
import Popup from "../../../ReusableFunctions/Popup";
import { sendVerificationOTPOnSignUp, verifySignOtp } from "../../../apis/verification";
import { useNavigate } from "react-router";
import OTPInput from "react-otp-input";
import { GLOBAL_STYLES } from "../../../appConstants";
import { Link } from "react-router-dom";

export default function EmailVerifyStep() {
    const [resendOtpTimer, setResendOtpTimer] = useState(10);
    const [canResend, setCanResend] = useState(false);
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const {
        currentStep,
        setCurrentStep,
        signUpDetails,
        setSignUpDetails,
        setEmailMode,
    } = useSignUpContext();
    const navigate = useNavigate();

    const handleChange = (value) => {
        value = value.replace(/\D/g, "");
        if (value.length > 6) return;
        setOtp(value);
        setError("");
    };

    const handleVerify = async () => {
        if (otp.length !== 6) return;

        setLoading(true);
        setError("");

        try {
            await verifySignOtp({
                otp,
                email: signUpDetails.email,
            });

            const updated = {
                ...signUpDetails,
                isEmailVerified: true,
            };
            setSignUpDetails(updated);

            Popup.alert("SUCCESS", "OTP verified successfully", "SUCCESS", () => {
                // Email verified → move to Step 2 Enter Phone
                setEmailMode("ENTER"); // reset mode so if you come back it's on ENTER
                setCurrentStep(2);
            });
        } catch (err) {
            setError(
                err?.errorMessage || "Something went wrong. Please try again."
            );
            setLoading(false);
        }
    };

    const handleResendOtp = async () => {
        if (!canResend) return;
        setCanResend(false);
        setResendOtpTimer(10);
        try {
            await sendVerificationOTPOnSignUp({ email: signUpDetails.email });
            Popup.alert("SUCCESS", "OTP resent successfully", "SUCCESS");
        } catch (err) {
            Popup.alert("Error", "Failed to resend OTP", "ERROR");
        }
    };

    useEffect(() => {
        let interval;
        if (resendOtpTimer > 0) {
            interval = setInterval(() => {
                setResendOtpTimer((prev) => prev - 1);
            }, 1000);
        } else {
            setCanResend(true);
        }
        return () => clearInterval(interval);
    }, [resendOtpTimer]);

    return (
        <div className="w-[420px] h-[400px] py-4 mt-2">
            <p className="signUpform-title" style={{
                fontSize: "30px !important",
                fontWeight: 700
            }}>Create Your Account</p>

            <p className="font-manrope font-[600] text-[#1E1E1E] text-[17px] mt-2 mb-2">
                Verify Email
            </p>

            <p className="mt-1 leading-[18px] text-[13px] font-manrope w-[100%] font-medium text-gray-600">
                We’ve sent a 6 digit verification OTP to{" "}
                <span className="text-[#1E1E1E] font-manrope font-[600]">
                    {signUpDetails?.email}
                </span>
                </p>
            <div className="w-full py-4">
                <OTPInput
                    value={otp}
                    onChange={handleChange}
                    numInputs={6}
                    renderInput={(props, i) => (
                        <input
                            id={`input-email-otp-${i}`}
                            {...props}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && otp.length === 6 && !loading) {
                                    handleVerify();
                                }
                            }}
                        />
                    )}
                    inputStyle={{
                        width: "50px",
                        height: "50px",
                        margin: "0px 20px 0px 0px",
                        fontSize: "20px",
                        fontWeight: 500,
                        border: `1px solid ${GLOBAL_STYLES.BORDER_COLOR}`,
                        borderRadius: "7px",
                    }}
                />
                {error && (
                    <div className="min-h-[20px] mt-2 text-[#EA0606] text-[12px] w-full">
                        {error}
                    </div>
                )}
            </div>

            <div className="flex justify-end">
                {canResend ? (
                    <span
                        onClick={handleResendOtp}
                        className="font-manrope font-[600] text-[13px] text-[#0F5EFF] cursor-pointer"
                    >
                        Resend OTP
                    </span>
                ) : (
                    <span className="font-manrope font-[500] text-[13px] text-[#1E1E1E]">
                        Resend OTP in {resendOtpTimer}
                    </span>
                )}
            </div>

            <button
                onClick={handleVerify}
                disabled={loading || otp.length !== 6}
                className={`w-full mt-4 py-2 rounded-md text-white font-semibold ${otp.length === 6 && !loading
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-[#0F5EFF] opacity-60 cursor-not-allowed"
                    }`}
            >
                Verify
            </button>

            <p className="mt-4 text-center font-manrope font-[500] text-sm text-[#3B3B3B]">
                Already have an account?{" "}
                <Link
                    to={"/login"}
                    style={{
                        color: GLOBAL_STYLES.BG_ACTIVE,
                        textDecoration: "none",
                        fontWeight: 700,
                    }}
                >
                    Log in
                </Link>
            </p>
        </div>
    );
}
